import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H3, Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { useChecklistArb } from "../../hooks/use-arb";
import { StatusEnum } from "../../utility/enums/common";
import { renderBGColor } from "../task";

interface Props {
  status: StatusEnum;
  image: JSX.Element;
  descriptionText: React.ReactNode;
}

export const FlyOutStatusCard = ({ status, image, descriptionText }: Props) => {
  const bundle = useChecklistArb();

  const statusTitle = bundle.getMessage("checklist-General-Status");
  const detailsTitle = bundle.getMessage("Checklist-CardControlled-DetailsTitle");

  return (
    <Col className="flyout-content">
      <Col gridGap="S300">
        <Card title={statusTitle}>
          <Row>
            <Col
              backgroundColor={renderBGColor(status)}
              width={"S100"}
              data-testid={`flyout-status-text-${status}`}
            ></Col>
            <Col gridGap={"S300"} padding={"S300"}>
              <H3 fontSize={"T400"}>{statusTitle}</H3>
              {image}
            </Col>
          </Row>
        </Card>
        <Card>
          <Col gridGap={"S300"} data-testid="flyout-details-text">
            <H3 fontSize={"T400"}>{detailsTitle}</H3>
            {React.isValidElement(descriptionText) ? descriptionText : <Text>{descriptionText}</Text>}
          </Col>
        </Card>
      </Col>
    </Col>
  );
};
